export interface AlarmStatus {
    fetchAt?: Date;
    Alarm: string;
    tempMtrs?: TempMtr[];
    pwrMtrs?: PwrMtr[];
    battMtrs?: BattMtr[];
    VSupplies: VSupply[];
}

export interface VSupply {
    V1: string;
    V2: string;
    V3: string;
    V4: string;
    I1: string;
}

export interface PwrMtr {
    a16: string;
    pwrDlvd: string;
}

export interface TempMtr {
    a16: string;
    tempC: string;
}

export interface BattMtr {
    a16: string;
    battPerc: string;
}

export function mapJsonToAlarmStatus(jsonString: string): AlarmStatus {
    const json = JSON.parse(jsonString);

    // Check if 'Tm' is present and is an array before mapping.
    const tempMtrs = Array.isArray(json.Tm) ? json.Tm.map((tm: any) => ({
        a16: tm.A,
        tempC: tm.Tc
    })) : undefined;

    // Check if 'Pm' is present and is an array before mapping.
    const pwrMtrs = Array.isArray(json.Pm) ? json.Pm.map((pm: any) => ({
        a16: pm.A,
        pwrDlvd: pm.Pd
    })) : undefined;

    // Check if 'Bm' is present and is an array before mapping.
    const battMtrs = Array.isArray(json.Bm) ? json.Bm.map((bm: any) => ({
        a16: bm.A,
        battPerc: bm.Bp
    })) : undefined;

    // Check if 'Vs' is present and is an array before mapping.
    const VSupplies = Array.isArray(json.Vs) ? json.Vs.map((vs: any) => ({
        V1: vs.V1,
        V2: vs.V2,
        V3: vs.V3,
        V4: vs.V4,
        I1: vs.I1,
    })) : [];

    return {
        fetchAt: new Date(),
        Alarm: json.Al,
        tempMtrs: tempMtrs,
        pwrMtrs: pwrMtrs,
        battMtrs: battMtrs,
        VSupplies: VSupplies
    };
}

export interface ILocationFromDatabase {
    id: number;
    coreId: string;
    insertedDate: string;
    gpsTimestamp: string;
    longitude: number;
    latitude: number;
    valid: number;
}

export interface IGeofenceArmingInfo {
    id?: number;
    coreId?: string;
    insertedDate?: string;
    gpsTimestamp?: string;
    longitude?: number;
    latitude?: number;
    valid?: number;
    ageSeconds?: number;
    hasInvalidAfterValid?: boolean;
    lastInvalidTimestamp?: string | null;
    geofenceRadiusMeters?: number;
}

export interface IGeofenceArmRequest {
    latitude?: number;
    longitude?: number;
    accuracyConfirmed?: boolean;
}

export interface ILocationFromParticle {
    location: Location;
}

export interface Location {
    device_id: string;
    geometry: Geometry;
    sources: string[];
    horizontal_accuracy: number;
    product_id: number;
    last_heard: string;
    gps_lock: boolean;
    triggers: string[];
    timestamps: string[];
    properties: any[];
    device_name: string;
    groups: any[];
    online: boolean;
}

export interface Geometry {
    type: string;
    coordinates: number[];
}

//export interface IGeoLocation {
//    longitude: string;
//    latitude: string;
//    gpsTimestamp: Date;
//}
export interface IMiscInfo {
    Devices: string;
    GpsPositions: string;
    GpsLocus: string;
    Events: string;
    Orders: string;
    ResponsesAwaiting: string;
    Radius_GPS: string;
    RAM_Mem: string;
    EEPROM_Mem: string;
    Temperature: string;
}
export interface IStatusChange {
    device: string;
    status: string;
    age: string;
    atPosition: AtPosition[];
}
export interface ISensorAge {
    device: string;
    status: string;
    age: string;
    atPosition: AtPosition[];
}

export interface AtPosition {
    pos: string;
}